// !!! THIS FILE IS GENERATED BY codegen.js !!!
export const ma0 = {
    'margin-top': 0,
    'margin-right': 0,
    'margin-bottom': 0,
    'margin-left': 0
};
export const ma1 = {
    'margin-top': 8,
    'margin-right': 8,
    'margin-bottom': 8,
    'margin-left': 8
};
export const ma2 = {
    'margin-top': 16,
    'margin-right': 16,
    'margin-bottom': 16,
    'margin-left': 16
};
export const ma3 = {
    'margin-top': 32,
    'margin-right': 32,
    'margin-bottom': 32,
    'margin-left': 32
};
export const ma4 = {
    'margin-top': 64,
    'margin-right': 64,
    'margin-bottom': 64,
    'margin-left': 64
};
export const ma5 = {
    'margin-top': 128,
    'margin-right': 128,
    'margin-bottom': 128,
    'margin-left': 128
};
export const ma6 = {
    'margin-top': 256,
    'margin-right': 256,
    'margin-bottom': 256,
    'margin-left': 256
};
export const mh0 = {
    'margin-left': 0,
    'margin-right': 0
};
export const mh1 = {
    'margin-left': 8,
    'margin-right': 8
};
export const mh2 = {
    'margin-left': 16,
    'margin-right': 16
};
export const mh3 = {
    'margin-left': 32,
    'margin-right': 32
};
export const mh4 = {
    'margin-left': 64,
    'margin-right': 64
};
export const mh5 = {
    'margin-left': 128,
    'margin-right': 128
};
export const mh6 = {
    'margin-left': 256,
    'margin-right': 256
};
export const mv0 = {
    'margin-top': 0,
    'margin-bottom': 0
};
export const mv1 = {
    'margin-top': 8,
    'margin-bottom': 8
};
export const mv2 = {
    'margin-top': 16,
    'margin-bottom': 16
};
export const mv3 = {
    'margin-top': 32,
    'margin-bottom': 32
};
export const mv4 = {
    'margin-top': 64,
    'margin-bottom': 64
};
export const mv5 = {
    'margin-top': 128,
    'margin-bottom': 128
};
export const mv6 = {
    'margin-top': 256,
    'margin-bottom': 256
};
export const mt0 = {
    'margin-top': 0
};
export const mt1 = {
    'margin-top': 8
};
export const mt2 = {
    'margin-top': 16
};
export const mt3 = {
    'margin-top': 32
};
export const mt4 = {
    'margin-top': 64
};
export const mt5 = {
    'margin-top': 128
};
export const mt6 = {
    'margin-top': 256
};
export const mr0 = {
    'margin-right': 0
};
export const mr1 = {
    'margin-right': 8
};
export const mr2 = {
    'margin-right': 16
};
export const mr3 = {
    'margin-right': 32
};
export const mr4 = {
    'margin-right': 64
};
export const mr5 = {
    'margin-right': 128
};
export const mr6 = {
    'margin-right': 256
};
export const mb0 = {
    'margin-bottom': 0
};
export const mb1 = {
    'margin-bottom': 8
};
export const mb2 = {
    'margin-bottom': 16
};
export const mb3 = {
    'margin-bottom': 32
};
export const mb4 = {
    'margin-bottom': 64
};
export const mb5 = {
    'margin-bottom': 128
};
export const mb6 = {
    'margin-bottom': 256
};
export const ml0 = {
    'margin-left': 0
};
export const ml1 = {
    'margin-left': 8
};
export const ml2 = {
    'margin-left': 16
};
export const ml3 = {
    'margin-left': 32
};
export const ml4 = {
    'margin-left': 64
};
export const ml5 = {
    'margin-left': 128
};
export const ml6 = {
    'margin-left': 256
};
export const pa0 = {
    'padding-top': 0,
    'padding-right': 0,
    'padding-bottom': 0,
    'padding-left': 0
};
export const pa1 = {
    'padding-top': 8,
    'padding-right': 8,
    'padding-bottom': 8,
    'padding-left': 8
};
export const pa2 = {
    'padding-top': 16,
    'padding-right': 16,
    'padding-bottom': 16,
    'padding-left': 16
};
export const pa3 = {
    'padding-top': 32,
    'padding-right': 32,
    'padding-bottom': 32,
    'padding-left': 32
};
export const pa4 = {
    'padding-top': 64,
    'padding-right': 64,
    'padding-bottom': 64,
    'padding-left': 64
};
export const pa5 = {
    'padding-top': 128,
    'padding-right': 128,
    'padding-bottom': 128,
    'padding-left': 128
};
export const pa6 = {
    'padding-top': 256,
    'padding-right': 256,
    'padding-bottom': 256,
    'padding-left': 256
};
export const ph0 = {
    'padding-left': 0,
    'padding-right': 0
};
export const ph1 = {
    'padding-left': 8,
    'padding-right': 8
};
export const ph2 = {
    'padding-left': 16,
    'padding-right': 16
};
export const ph3 = {
    'padding-left': 32,
    'padding-right': 32
};
export const ph4 = {
    'padding-left': 64,
    'padding-right': 64
};
export const ph5 = {
    'padding-left': 128,
    'padding-right': 128
};
export const ph6 = {
    'padding-left': 256,
    'padding-right': 256
};
export const pv0 = {
    'padding-top': 0,
    'padding-bottom': 0
};
export const pv1 = {
    'padding-top': 8,
    'padding-bottom': 8
};
export const pv2 = {
    'padding-top': 16,
    'padding-bottom': 16
};
export const pv3 = {
    'padding-top': 32,
    'padding-bottom': 32
};
export const pv4 = {
    'padding-top': 64,
    'padding-bottom': 64
};
export const pv5 = {
    'padding-top': 128,
    'padding-bottom': 128
};
export const pv6 = {
    'padding-top': 256,
    'padding-bottom': 256
};
export const pt0 = {
    'padding-top': 0
};
export const pt1 = {
    'padding-top': 8
};
export const pt2 = {
    'padding-top': 16
};
export const pt3 = {
    'padding-top': 32
};
export const pt4 = {
    'padding-top': 64
};
export const pt5 = {
    'padding-top': 128
};
export const pt6 = {
    'padding-top': 256
};
export const pr0 = {
    'padding-right': 0
};
export const pr1 = {
    'padding-right': 8
};
export const pr2 = {
    'padding-right': 16
};
export const pr3 = {
    'padding-right': 32
};
export const pr4 = {
    'padding-right': 64
};
export const pr5 = {
    'padding-right': 128
};
export const pr6 = {
    'padding-right': 256
};
export const pb0 = {
    'padding-bottom': 0
};
export const pb1 = {
    'padding-bottom': 8
};
export const pb2 = {
    'padding-bottom': 16
};
export const pb3 = {
    'padding-bottom': 32
};
export const pb4 = {
    'padding-bottom': 64
};
export const pb5 = {
    'padding-bottom': 128
};
export const pb6 = {
    'padding-bottom': 256
};
export const pl0 = {
    'padding-left': 0
};
export const pl1 = {
    'padding-left': 8
};
export const pl2 = {
    'padding-left': 16
};
export const pl3 = {
    'padding-left': 32
};
export const pl4 = {
    'padding-left': 64
};
export const pl5 = {
    'padding-left': 128
};
export const pl6 = {
    'padding-left': 256
};
export const spaces = [0, 8, 16, 32, 64, 128, 256];



// WEBPACK FOOTER //
// ./src/theme/layout/spacing.ts